export const LICENSE_LISTS_ASSIGNED_TAB_TEXT = 'Assigned Licenses '
export const LICENSE_LISTS_UNASSIGNED_TAB_TEXT = 'Unassigned Licenses '
export const LICENSE_LISTS_UNASSIGNED_TEXT =
  'You have no licenses left that require assignment.'
export const LICENSE_LISTS_ASSIGNED_TEXT = 'No licenses have been assigned.'
export const LICENSE_LISTS_EXPIRED_TEXT = 'No inactive Licenses.'
export const LICENSE_LISTS_EXPIRED_TAB_TEXT = 'Inactive Licenses '
